export const COMPANION_PRESET_VALUES = [
  'standard',
  'discret',
  'expressif',
  'sans-compagnons',
  'guide-souris',
] as const;

export type CompanionPreset = (typeof COMPANION_PRESET_VALUES)[number];

export type CompanionPresetConfig = {
  scale: number;
  showCompanions: boolean;
  followMouse: boolean;
  platformScale: number;
  companionShape: 'idle' | 'puffy';
};

export const COMPANION_PRESET_CONFIG: Record<CompanionPreset, CompanionPresetConfig> = {
  standard: {
    scale: 1,
    showCompanions: true,
    followMouse: false,
    platformScale: 1.1,
    companionShape: 'idle',
  },
  discret: {
    scale: 0.55,
    showCompanions: true,
    followMouse: false,
    platformScale: 1.0,
    companionShape: 'idle',
  },
  expressif: {
    scale: 1.35,
    showCompanions: true,
    followMouse: false,
    platformScale: 1.15,
    companionShape: 'puffy',
  },
  'sans-compagnons': {
    scale: 0,
    showCompanions: false,
    followMouse: false,
    platformScale: 1.1,
    companionShape: 'idle',
  },
  'guide-souris': {
    scale: 1,
    showCompanions: true,
    followMouse: true,
    platformScale: 1.1,
    companionShape: 'idle',
  },
};

export const DEFAULT_COMPANION_PRESET: CompanionPreset = 'standard';

export function getCompanionPresetConfig(
  preset: CompanionPreset | null | undefined,
): CompanionPresetConfig {
  return COMPANION_PRESET_CONFIG[preset ?? DEFAULT_COMPANION_PRESET];
}

/** Extrait la clé preset depuis le composant Strapi (ou fallback). */
export function getCompanionPresetKey(
  value: { preset?: CompanionPreset | null } | null | undefined,
  fallback: CompanionPreset = DEFAULT_COMPANION_PRESET,
): CompanionPreset {
  return value?.preset ?? fallback;
}
